{
  "description": "Saved from a Run.",
  "kinds": {"reply_turn": "Reply", "step_turn": "Step"},
  "name": "Name of the process schema",
  "nextVersion": "Saves as the next version of “{{name}}”.",
  "nothing": "This Run has no completed step or reply yet.",
  "open": "Create a process schema from this Run",
  "pick": "Use entry {{number}}",
  "projectVersion": "Saves your project's version of “{{name}}”.",
  "save": "Propose the process schema",
  "start": "How the step starts",
  "starts": {"automatic": "Right after the step before", "on_request": "When someone starts it"},
  "subtitle": "The steps and replies you pick become a process schema, proposed for review.",
  "title": "Create a process schema from this Run"
}
